import { AppError } from "../../../app-store-error.types";
import { TransferQuotesState, initialTransferQuotesState } from "./transfer-quotes/transfer-quotes.state";
import { AutoArchiveState, initialAutoArchiveState } from "./auto-archive/auto-archive.state";
import { InactiveCustomersState, initialInactiveCustomersState } from "./inactive-customers/inactive-customers.state";
import { SendReminderState, initialSendReminderState } from "./send-reminder/send-reminder.state";
import { EmailLogsState, initialEmailLogsState } from "./email-logs/email-logs.state";
import { WebhooksState, initialWebhooksState } from "./webhooks/webhooks.state";
import { AttioQuoteMigrationState, initialAttioQuoteMigrationState } from "./attio-quote-migration/attio-quote-migration.state";
import { AttioRecordMigrationState, initialAttioRecordMigrationState } from "./attio-record-migration/attio-record-migration.state";

// **************************************************************************
// DEVELOPER STATE
// **************************************************************************
export interface DeveloperState {
    transferQuotes: TransferQuotesState;
    autoArchive: AutoArchiveState;
    inactiveCustomers: InactiveCustomersState;
    sendReminder: SendReminderState;
    emailLogs: EmailLogsState;
    webhooks: WebhooksState;
    attioQuoteMigration: AttioQuoteMigrationState;
    attioRecordMigration: AttioRecordMigrationState;
    error: AppError | null;
}

export const initialDeveloperState: DeveloperState = {
    transferQuotes: initialTransferQuotesState,
    autoArchive: initialAutoArchiveState,
    inactiveCustomers: initialInactiveCustomersState,
    sendReminder: initialSendReminderState,
    emailLogs: initialEmailLogsState,
    webhooks: initialWebhooksState,
    attioQuoteMigration: initialAttioQuoteMigrationState,
    attioRecordMigration: initialAttioRecordMigrationState,
    error: null,
};
